module.exports = __webpack_public_path__ + "img/eng-lqtafsir-1.860438b0.webp";